<admin-app-header></admin-app-header>

<div class="container-fluid admin-page py-4">
    <div class="row align-items-center mb-3">
        <div class="col-8">
            <h2 class="mb-1">FAQs</h2>
            <p class="text-muted mb-0">Manage the questions and answers shown on the public /faqs page.</p>
        </div>
        <div class="col-4 text-end">
            <a [routerLink]="['/admin/cms/faqs/create']" class="btn btn-primary">
                <i class="fa-solid fa-plus me-1"></i> New FAQ
            </a>
        </div>
    </div>

    <div *ngIf="loading" class="text-muted py-3">Loading FAQs...</div>

    <ng-container *ngIf="!loading">
        <ng-container *ngTemplateOutlet="faqTable; context: { $implicit: clientFaqs, title: 'Driver FAQs', empty: 'No driver FAQs yet.', list: clientFaqs }"></ng-container>
        <ng-container *ngTemplateOutlet="faqTable; context: { $implicit: merchantFaqs, title: 'Property Owner FAQs', empty: 'No property-owner FAQs yet.', list: merchantFaqs }"></ng-container>
    </ng-container>

    <ng-template #faqTable let-faqs let-title="title" let-empty="empty" let-list="list">
        <div class="card mb-4">
            <div class="card-header bg-light">
                <strong>{{ title }}</strong>
                <span class="text-muted ms-2">({{ faqs.length }})</span>
            </div>
            <div class="card-body p-0">
                <table class="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th style="width: 80px">Order</th>
                            <th>Question</th>
                            <th style="width: 110px">Status</th>
                            <th style="width: 160px" class="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="faqs.length === 0">
                            <td colspan="4" class="text-muted text-center py-3">{{ empty }}</td>
                        </tr>
                        <tr *ngFor="let faq of faqs; trackBy: trackByKey">
                            <td>
                                <div class="d-flex align-items-center gap-1">
                                    <button type="button" class="btn btn-sm btn-outline-secondary px-2 py-0" (click)="moveUp(faq, list)" title="Move up">
                                        <i class="fa-solid fa-arrow-up"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-secondary px-2 py-0" (click)="moveDown(faq, list)" title="Move down">
                                        <i class="fa-solid fa-arrow-down"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <a [routerLink]="['/admin/cms/faqs/', faq.$key]">
                                    {{ faq.question || '(no question)' }}
                                </a>
                            </td>
                            <td>
                                <span class="badge" [class.bg-success]="faq.published" [class.bg-secondary]="!faq.published">
                                    {{ faq.published ? 'Published' : 'Draft' }}
                                </span>
                            </td>
                            <td class="text-end">
                                <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="togglePublished(faq)">
                                    {{ faq.published ? 'Unpublish' : 'Publish' }}
                                </button>
                                <a [routerLink]="['/admin/cms/faqs/', faq.$key]" class="btn btn-sm btn-outline-primary me-1">
                                    <i class="fa-solid fa-pen"></i>
                                </a>
                                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteFaq(faq)">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-template>
</div>
